import { ReportChatRequest, ReportChatReason } from './chat.type';

export const reportChat = (body: ReportChatRequest) => {
  return apiClient().post('/ReportChat', body);
};

export const getReportChatReasons = async () => {
  const response = await apiClient().get<{ reason: ReportChatReason[] }>('/ReportChat/reasons');

  return response?.data?.reason || [];
};
